export enum Theme {
  Dark = 'Dark',
  Light = 'Light',
}
